import React, {useCallback, useEffect, useState} from "react";
import {Button, Col, Input, message, Row} from "antd";
import Icon from "@ant-design/icons";
import './index.less'
import axios from "../../../utils/selfRequest";
import {PhoneIcon, VerificationIcon} from './svg'
import {language} from "@/utils/language";
import PubSub from "pubsub-js";
// 手机验证题
let buttonCountDownTimer = null
export default function Phone(props) {

    const {
        info: {smsVerificationRequired, id}, surveyId, answer, changeAnswer,
    } = props;


    const [phone, setPhone] = useState('');
    const [code, setCode] = useState('');
    const [phoneInputStatus, setPhoneInputStatus] = useState('');
    const [buttonCountDownTime, setButtonCountDownTime] = useState(0);
    const [buttonLoading, setButtonLoading] = useState(false)
    const [alertDisplay, setAlertDisplay] = useState(false);

    //hook
    useEffect(() => {
        PubSub.subscribe("phoneFormatErr", (msg, data) => {
            setPhoneInputStatus('error')
            setAlertDisplay(true)
        })
        PubSub.subscribe("phoneFormatErrClear", (msg, data) => {
            setAlertDisplay(false)
            setPhoneInputStatus(null)
        })
    }, [])

    useEffect(() => {
        if (buttonCountDownTime >= 60) {
            buttonCountDownTimer = setInterval(() => setButtonCountDownTime(t => --t), 1000);
        } else if (buttonCountDownTime <= 0) {
            clearInterval(buttonCountDownTimer)
        }
    }, [buttonCountDownTime])

    useEffect(() => {
        if (id && Object.keys(answer).length > 0 && phone.length <= 0 && code.length <= 0) {
            setPhone(answer[id]?.['phone']?.text || '')
            setCode(answer[id]?.['verificationCode']?.text || '')
        }
    }, [answer])


    //function
    const onButtonClick = () => {
        if (buttonCountDownTime > 0) {
            return;
        }
        if (!(/^1\d{10}$/.test(phone))) {
            PubSub.publish("phoneFormatErr");
            return
        }
        setButtonLoading(true)
        PubSub.publish("phoneFormatErrClear");

        axios.get('answer/test/sms/send',
            {
                questionId: id,
                phone: phone
            }, undefined, {
                id: surveyId
            }
        ).then((res) => {
            setButtonLoading(false)
            setButtonCountDownTime(60)
            message.success(language().sms_send_success)
        }).catch((err) => {
            message.error(err.msg);
            setButtonLoading(false)
        })
    }

    const refreshAnswer = (_phone, _code) => {
        const newAnswer = {}
        newAnswer['phone'] = {
            text: _phone
        }
        newAnswer['verificationCode'] = {
            text: _code
        }
        changeAnswer(newAnswer)
    }

    return (
        <div>
            <p className={'alert'}
               style={alertDisplay ? {} : {display: 'none'}}>{language().phone_format_err}</p>
            <Row gutter={[24, 24]} className={'phone'} wrap={false}>
                <Col span={24} className={'col'} style={{padding: '6px'}}>
                    <Input
                        status={phoneInputStatus}
                        className={'input'}
                        prefix={<Icon component={PhoneIcon}/>}
                        placeholder={language().phone_input}
                        value={phone}
                        onChange={(e) => {
                            refreshAnswer(e.target.value, code);
                            setPhone(e.target.value);
                        }}
                    />
                </Col>
            </Row>
            <Row gutter={[24, 24]} className={'phone'} wrap={false} style={smsVerificationRequired !== 1 ? {display: "none"} : {}}>
                <Col flex="auto" style={{padding: '6px'}}>
                    <Input className={'input'}
                           prefix={<Icon component={VerificationIcon}/>}
                           placeholder={language().phone_verification_input}
                           value={code}
                           onChange={(e) => {
                               refreshAnswer(phone, e.target.value);
                               setCode(e.target.value);
                           }}
                    />
                </Col>
                <Col flex="none" style={{padding: '6px'}}>
                    <Button className={'button'}
                            type="primary"
                            disabled={buttonCountDownTime > 0}
                            loading={buttonLoading}
                            onClick={onButtonClick}>{buttonCountDownTime > 0 ? buttonCountDownTime + '秒' : language().phone_verification_send
                    }</Button>
                </Col>
            </Row>
        </div>
    );
}
